import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Box } from '@elparking/components'
import LoadingBlock from 'commons/js/ui/LoadingBlock'

const StepTwoData = ({ description }) => !description
    ? <LoadingBlock color='gray40' size='large' width='100%' />
    : <Box><Copy padding='0' fontWeight='medium'>{description}</Copy></Box>

StepTwoData.propTypes = {
    description: PropTypes.string,
}

export default StepTwoData
